module.exports = __webpack_public_path__ + "components/popular-cities-header/static/header--medium-757f3d1208bbd0ee544837ca892e36e3.jpg";